<div class="Nav-Bar">
  <div class="Nav-Bar__Container">
    <div class="Nav-Bar__Container--Container-Logo">
      <div class="Nav-Bar__Container--Container-Logo--Logo">
        <img src="./assets/Global/Icon_SINCO.png" alt="">
      </div>
      <div class="Nav-Bar__Container--Container-Logo--Title">
        CDMS<span>Librerías</span>
      </div>
    </div>
    <div class="Nav-Bar__Container--InfoUser"></div>
  </div>
</div>

<div class="Body container-global-components">
  <div class="Body__Container">
    <div class="Body__Container--Image">
      <img src="./assets/Global/Ilustrations/Not_Permission.png" alt="">
    </div>
    <div class="Body__Container--Title">
      Administrative Processes
    </div>
    <div class="Body__Container--Subtitle">
      {{GetGreeting()}}, {{NameUser()}}, te informamos que próximamente podrás consultar los procesos internos que
      corresponden a los departamentos de Finanzas, RH, IT y Seguridad. Pronto lo daremos a conocer.

    </div>
    <div class="Body__Container--Button">
      <button class="btn-icon-text">
        <a href="#"></a>
        <span class="text">Home</span><i class="fa-solid fa-house"></i>
      </button>
    </div>
  </div>
</div>